import { API_ENDPOINTS } from "@iso/constants/apiEndpoints.constant";

import BaseService from "./base.service";

export default class TaskStatusService extends BaseService {
  fetchAllTaskStatus = () => {
    return this.axios.get(API_ENDPOINTS.FETCH_ALL_TASK_STATUS);
  };

  getTaskStatusesByScreen = ({ screen }) => {
    return this.axios.get(API_ENDPOINTS.FETCH_TASK_STATUS_BY_SCREEN, {
      params: { screen },
    });
  };
}
